module.exports = __webpack_public_path__ + "img/Wachtkamer.8ffe99c5.jpg";